import { ChangeDetectionStrategy, Component } from '@angular/core';

import { WhiteLabelService } from '@flexyoo/common';

@Component({
  selector: 'app-sidenav-logo',
  templateUrl: './sidenav-logo.component.html',
  styleUrl: './sidenav-logo.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavLogoComponent {
  constructor(public wls: WhiteLabelService) {}
}
